import Icon from '@/components/ui/AppIcon';

interface Stat {
  id: string;
  label: string;
  value: string;
  change: string;
  icon: string;
  description: string;
}

const stats: Stat[] = [
  {
    id: 'stat_year',
    label: 'Books This Year',
    value: '42',
    change: '+8 from last month',
    icon: 'CalendarIcon',
    description: 'Reading goal: 52 books',
  },
  {
    id: 'stat_total',
    label: 'Total Reviews',
    value: '247',
    change: 'Since 2020',
    icon: 'DocumentTextIcon',
    description: 'Across all genres',
  },
  {
    id: 'stat_genres',
    label: 'Genres Covered',
    value: '15',
    change: '+2 this year',
    icon: 'Squares2X2Icon',
    description: 'From classics to contemporary',
  },
  {
    id: 'stat_avg',
    label: 'Average Rating',
    value: '4.2',
    change: 'Out of 5.0',
    icon: 'StarIcon',
    description: 'Quality-focused selections',
  },
];

export default function ReadingStats() {
  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-serif font-semibold text-foreground mb-6 tracking-tight">
            Reading Journey
          </h2>
          <p className="text-muted-foreground font-light">
            Tracking my literary adventures through numbers and milestones
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="glass-card p-8 rounded-xl hover:bg-card/80 transition-all duration-300 group cursor-default relative overflow-hidden"
            >
              {/* Background Decoration */}
              <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full bg-primary/5 blur-3xl group-hover:bg-primary/10 transition-colors" />

              {/* Icon */}
              <div className="relative w-14 h-14 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Icon name={stat.icon as any} size={28} className="text-primary" />
              </div>

              {/* Content */}
              <div className="relative">
                <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-3">
                  {stat.label}
                </div>

                <div className="text-5xl font-serif font-light text-foreground mb-2">
                  {stat.value}
                </div>

                <div className="text-sm text-accent mb-3">
                  {stat.change}
                </div>

                <p className="text-xs text-muted-foreground leading-relaxed">
                  {stat.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Insight */}
        <div className="mt-12 glass-card p-8 rounded-xl text-center">
          <p className="text-lg text-foreground font-light leading-relaxed max-w-3xl mx-auto">
            "Every book is a journey, and every review is an invitation to explore. 
            Join me as I navigate the vast landscape of literature, one page at a time."
          </p>
          <div className="mt-6 flex items-center justify-center gap-3">
            <div className="w-12 h-px bg-border" />
            <Icon name="BookmarkIcon" size={20} className="text-primary" />
            <div className="w-12 h-px bg-border" />
          </div>
        </div>
      </div>
    </section>
  );
}